import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, Optional, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatCalendar, MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';

@Component({
    selector: 'app-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.scss'],
    standalone: false
})
export class DateRangeComponent<D = Date> implements OnChanges, OnInit {
    @Input() beginDate: D;
    @Input() endDate: D;
    @Output() rangeSelected = new EventEmitter<{begin: D, end: D}>();

  public ranges: Array<{key: string, label: string}> = [
    {key: 'last7Days', label : 'Last 7 days'},
    {key: 'last30Days', label : 'Last 30 days'},
    {key: 'last90Days', label : 'Last 90 days'},
    {key: 'last365Days', label : 'Last 365 days'}
  ];
  private destroyed = new Subject<void>();
  activeDate: string;
  constructor(@Optional() private readonly calendar: MatCalendar<D>,
              @Optional() private readonly datePicker: MatDatepicker<D>,
              @Optional() private readonly dateAdapter: DateAdapter<D>,
              private readonly cdr: ChangeDetectorRef) {
      if (calendar) {
        calendar.stateChanges
              .pipe(takeUntil(this.destroyed))
              .subscribe(() => cdr.markForCheck());
      }
    }

  ngOnInit() {
    if (this.beginDate) {
      this.setActiveDate();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.beginDate || changes.endDate) {
      this.setActiveDate();
    }
  }

 setRange(range: string) {
    switch (range) {
      case 'last7Days':
        this.beginDate = moment().subtract(6, 'days').toDate() as D;
        this.endDate = new Date() as D;
        break;
      case 'last30Days':
        this.beginDate = moment().subtract(29, 'days').toDate() as D;
        this.endDate = new Date() as D;
        break;
      case 'last90Days':
        this.beginDate = moment().subtract(89, 'days').toDate() as D;
        this.endDate = new Date() as D;
        break;
      case 'last365Days':
        this.beginDate = moment().subtract(364, 'days').toDate() as D;
        this.endDate = new Date() as D;
        break;
    }
    this.setActiveDate();
    this.rangeSelected.emit({begin: this.beginDate, end: this.endDate});
    // Auto-close the picker after range selection
    if (this.datePicker) {
      this.datePicker.close();
    }
  }

  private setActiveDate() {
    const startDate = moment(this.beginDate);
    const endDate = moment(this.endDate);
    const diff = (startDate.diff(endDate, 'days'));
    switch (diff) {
      case -6 : this.activeDate = 'last7Days'; break;
      case -29 : this.activeDate = 'last30Days'; break;
      case -89 : this.activeDate = 'last90Days'; break;
      case -364 : this.activeDate = 'last365Days'; break;
      default : this.activeDate = null;
    }
  }

}
